__webpack_require__.hmrF = function() { return "tinper-style." + __webpack_require__.h() + ".hot-update.json"; };